import { createRef, RefObject, useEffect, useState } from "react";
import { Button, InputGroup } from "reactstrap";
import PlaylistData from "../playlist/data/PlaylistData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { DelayedFilterInput } from "../common/DelayedFilterInput";
import { CyFilterHeader } from "../common/components/multiselectablelist/CyFilterHeader";
import { useTranslation } from "react-i18next";

interface Props {
  performSearch: (searchTerm: string) => void;
  OrderByBuilder: (orderByProps: {
    title: string;
    field: keyof PlaylistData;
    dataCy?: string;
  }) => JSX.Element;
  visible: boolean;
  currentCrewIdentifier: string | undefined;
}

//TODO: Use generic FilterHeader
export function FilterHeader({
  performSearch,
  OrderByBuilder,
  visible,
  currentCrewIdentifier,
}: Props) {
  const { t } = useTranslation();
  const [isFilterActive, setIsFilterActive] = useState<boolean>(false);

  const searchfieldRef: RefObject<HTMLInputElement> = createRef();

  useEffect(() => {
    setIsFilterActive(false);
  }, [currentCrewIdentifier]);

  return (
    <InputGroup className={visible ? "" : "d-none"}>
      <Button
        color="primary"
        onClick={() =>
          setIsFilterActive((p) => {
            performSearch("");
            return !p;
          })
        }
        className="me-2"
        active={isFilterActive}
        data-cy={CyFilterHeader.ButtonToggleFilter}
      >
        <FontAwesomeIcon icon={faSearch} />
      </Button>
      {isFilterActive ? (
        <DelayedFilterInput
          onSearchTermChanged={performSearch}
          autoFocus={true}
          inputRef={searchfieldRef}
          placeholder={t("playlist.index.searchPlaylist")}
        />
      ) : (
        <OrderByBuilder
          title={t("common.playlist")}
          field="titleLowercase"
          dataCy={CyFilterHeader.ButtonOrderBy}
        />
      )}
    </InputGroup>
  );
}
